export const linksDiscente = [
  {
    name: 'Dashboard',
    icon: 'home',
    path: '/discente/dashboard'
  },
  {
    name: 'Estender bolsa',
    icon: 'plus',
    path: '/discente/estender'
  },
  {
    name: 'Perfil',
    icon: 'profile',
    path: '/discente/perfil'
  }
]
